import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Store from './store';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import './material-ui/roboto-font.css';
import './material-ui/font-icons.css';
import { createHashHistory } from 'history';
import './index.css';
import { ConnectedRouter } from 'connected-react-router';

const history = createHashHistory()

// Store.subscribe(() =>
//     console.log(Store.getState())
// )


// console.log(process.env)
ReactDOM.render(
  <Provider store={Store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root') as HTMLElement
);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx